/**
 * GTM dataLayer event for a successful Form submission. The name is the contract with GTM, whose
 * Custom Event trigger matches it exactly; letters only, so it is a legal GA4 event name too.
 */
export function logFormSubmitEvent(formType: string) {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'marketingFormSubmission',
    // The resolved form type ('demo_product'), never a numeric id or a human-readable name.
    formType,
    // GTM's "Form ID" variable reads gtm.elementId, which GTM's form listener otherwise sets to the
    // <form> element's HTML id (the Contentful formId). GA4 groups forms by type, so report that.
    'gtm.elementId': formType,
    formSuccess: true,
  });
}
